import { Button } from '@material-ui/core'
import cameraImage from 'assets/img/camera.png'
import * as React from 'react'
import ReactFileReader from 'react-file-reader'
import Form from './form'

import { Header, PopupLoader } from 'components'

export interface IProps {
  currentPatient: any
  croppedImage: string
  handleFiles: any
  loading: boolean
  valid: boolean
  onSubmit: any
}

class Content extends React.PureComponent<IProps> {
  render() {
    const { croppedImage, handleFiles, valid, onSubmit, loading } = this.props
    return (
      <div className="edit-patient-page page-min-content">
        <Header smallHeader={true} />
        <div className="edit-patient-content mobile-container">
          <div className="edit-section">
            <h3>Edit Child Profile</h3>
            <div className="photo-section">
              <ReactFileReader handleFiles={handleFiles} base64={true}>
                <React.Fragment>
                  <div className="logo">
                    <div className="wrapper">
                      <img
                        src={
                          croppedImage
                            ? typeof croppedImage === 'string'
                              ? croppedImage
                              : URL.createObjectURL(croppedImage)
                            : cameraImage
                        }
                        className={`camera-image ${croppedImage && 'active'}`}
                      />
                    </div>
                  </div>
                  {croppedImage ? undefined : <div className="add-button" />}
                </React.Fragment>
              </ReactFileReader>
            </div>
            <Form />
          </div>
          <Button
            className={`black-btn full-width ${!valid ? 'disabled' : ''}`}
            color="primary"
            onClick={onSubmit}
          >
            {'Submit'}
          </Button>
        </div>
        <PopupLoader active={loading} />
      </div>
    )
  }
}

export default Content



// WEBPACK FOOTER //
// ./src/pages/EditPatient/content.tsx